export const errorMessages = {
  required: (fieldName: string) => `${fieldName} is required`,
  invalidEmail: "Invalid email address",
  characterLimit: (fieldName: string, limit: number) =>
    `${fieldName} should not exceed ${limit} characters`,
  minCharacterLimit: (fieldName: string, limit: number) =>
    `${fieldName} must contain a minimum of ${limit} characters`,
  alphabetsAndSpaceValidation(fieldName: string) {
    return `${fieldName} must only contain alphabets and white spaces`;
  },
  length(fieldName: string, limit: number) {
    return `${fieldName} must contain ${limit} characters`;
  },
  previousPasswords() {
    return `Previous ${process.env.REACT_APP_PASSWORD_HISTORY_LIMIT} passwords cannot be reused.`;
  },
  npiLengthError: "NPI must have 10 digits",
  npiRegexMisMatch:
    "Invalid input. Please enter comma separated 10 digit numbers.",
  activeSessionExists:
    "An active session exists already, please try again later.",
  passwordRegexMatch:
    "Password must contain at least one uppercase letter, one lowercase letter, one special character and one number.",
  confirmPassword: "Passwords must match",
  passwordMismatch: "New password cannot be same as current password",
  renterPassword: "Re-enter your new password",
  passwordUpdateFailed: "Password changes failed. Please try again.",
  validEmail: "Enter valid email address",
  errorInfo: "An error occured.Try Again later!!",
};
